"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var marginBottom = '20px';

var createHeadlines = function createHeadlines(baseTheme) {
  return {
    headline: {
      '01': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size['5xl'],
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['7xl']
        }
      },
      '02': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size['4xl'],
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['6xl']
        }
      },
      '03': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size['3xl'],
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['5xl']
        }
      },
      '04': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size['2xl'],
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['3xl']
        }
      },
      '05': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size.xl,
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['2xl']
        }
      },
      '06': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size.xl,
        fontWeight: baseTheme.font.weight.sm,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size['2xl']
        }
      },
      '07': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size.lg,
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.xl
        }
      },
      '08': {
        fontFamily: baseTheme.font.family.highlight,
        fontSize: baseTheme.font.size.lg,
        fontWeight: baseTheme.font.weight.sm,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.xl
        }
      }
    }
  };
};

var createBody = function createBody(baseTheme) {
  return {
    body01: {
      lg: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.md,
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.xl,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.lg
        }
      },
      md: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.sm,
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.md
        }
      },
      sm: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.xs,
        fontWeight: baseTheme.font.weight.md,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.sm
        }
      }
    },
    body02: {
      lg: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.md,
        fontWeight: baseTheme.font.weight.sm,
        lineHeight: baseTheme.line.height.xl,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.lg
        }
      },
      md: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.sm,
        fontWeight: baseTheme.font.weight.sm,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.md
        }
      },
      sm: {
        fontFamily: baseTheme.font.family.base,
        fontSize: baseTheme.font.size.xs,
        fontWeight: baseTheme.font.weight.sm,
        lineHeight: baseTheme.line.height.lg,
        letterSpacing: baseTheme.letter.spacing.sm,
        marginBottom: marginBottom,
        md: {
          fontSize: baseTheme.font.size.sm
        }
      }
    }
  };
};

var typographyTheme = function typographyTheme(baseTheme) {
  return {
    typographyName: 'typography-jv',
    typographyVersion: '1.0.0',
    typo: _extends({}, createHeadlines(baseTheme), createBody(baseTheme), {
      lead: {
        text: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size['2xs'],
          fontWeight: baseTheme.font.weight.xl,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.xl,
          textTransform: baseTheme.font.transform.uppercase,
          marginBottom: marginBottom
        }
      },
      caption: {
        '01': {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size['2xs'],
          fontWeight: baseTheme.font.weight.md,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.xs
          }
        },
        '02': {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size['2xs'],
          fontWeight: baseTheme.font.weight.sm,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.xs
          }
        }
      },
      button01: {
        md: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.xs,
          fontWeight: baseTheme.font.weight.md,
          lineHeight: baseTheme.line.height.sm,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.sm
          }
        },
        sm: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size['2xs'],
          fontWeight: baseTheme.font.weight.md,
          lineHeight: baseTheme.line.height.sm,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.xs
          }
        }
      },
      button02: {
        md: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.xs,
          fontWeight: baseTheme.font.weight.sm,
          lineHeight: baseTheme.line.height.sm,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.sm
          }
        },
        sm: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size['2xs'],
          fontWeight: baseTheme.font.weight.sm,
          lineHeight: baseTheme.line.height.sm,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.xs
          }
        }
      },
      link: {
        xl: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.xl,
          fontWeight: baseTheme.font.weight.md,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size['2xl']
          }
        }
      },
      link01: {
        lg: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.md,
          fontWeight: baseTheme.font.weight.md,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.xl,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.lg
          }
        },
        md: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.sm,
          fontWeight: baseTheme.font.weight.md,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.md
          }
        },
        sm: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.xs,
          fontWeight: baseTheme.font.weight.md,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.sm
          }
        }
      },
      link02: {
        lg: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.md,
          fontWeight: baseTheme.font.weight.sm,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.xl,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.lg
          }
        },
        md: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.sm,
          fontWeight: baseTheme.font.weight.sm,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.md
          }
        },
        sm: {
          fontFamily: baseTheme.font.family.base,
          fontSize: baseTheme.font.size.xs,
          fontWeight: baseTheme.font.weight.sm,
          textDecoration: baseTheme.font.decoration.underline,
          lineHeight: baseTheme.line.height.lg,
          letterSpacing: baseTheme.letter.spacing.sm,
          marginBottom: marginBottom,
          md: {
            fontSize: baseTheme.font.size.sm
          }
        }
      }
    })
  };
};

var _default = typographyTheme;
exports["default"] = _default;